import { Dispatch } from "redux";

import {
  FETCH_ORGANIZATION_EVENTS_FOR_BOOKING_FAILURE,
  FETCH_ORGANIZATION_EVENTS_FOR_BOOKING_REQUEST,
  FETCH_ORGANIZATION_EVENTS_FOR_BOOKING_SUCCESS,
  FetchOrganizationEventsForBookingFailureAction,
  FetchOrganizationEventsForBookingRequestAction,
  FetchOrganizationEventsForBookingSuccessAction,
  OrganizationEventsForBookingActionTypes,
} from "./types";
import { OrganizationEventsForBookingData } from "../../models/organizationEventsForBookingData";
import { getDynamicTranslation } from "../../components/core/localization/localizationUtils";
import { enqueueSnackbar } from "notistack";
import { organizationEventsForBookingService } from "../../api";

/**
 * Dispatched when the organization events for booking request is made
 * @returns {OrganizationEventsForBookingRequestAction}
 */
export const fetchOrganizationEventsForBookingRequest =
  (): FetchOrganizationEventsForBookingRequestAction => {
    return {
      type: FETCH_ORGANIZATION_EVENTS_FOR_BOOKING_REQUEST,
    };
  };

/**
 * Dispatched when the organization events for booking request succeeds
 * @param {OrganizationEventsForBookingData[]} data The array of events returned after a successful booking request.
 * @returns {FetchOrganizationEventsForBookingSuccessAction}
 */
export const fetchOrganizationEventsForBookingSuccess = (
  data: OrganizationEventsForBookingData[]
): FetchOrganizationEventsForBookingSuccessAction => {
  return {
    type: FETCH_ORGANIZATION_EVENTS_FOR_BOOKING_SUCCESS,
    events: data,
  };
};

/**
 * Dispatched when the organization events for booking request fails
 * @returns {OrganizationEventsForBookingFailureAction}
 */
export const fetchOrganizationEventsForBookingFailure = (
  error: string
): FetchOrganizationEventsForBookingFailureAction => {
  return {
    type: FETCH_ORGANIZATION_EVENTS_FOR_BOOKING_FAILURE,
    error,
  };
};

/**
 * Fetches events for bookings by an organization.
 * @param organizationId The organization the orga admin is booking for.
 * @returns {Function} A function that dispatches actions
 */
export const fetchOrganizationEventsForBooking = (organizationId: string) => {
  return async (dispatch: Dispatch<OrganizationEventsForBookingActionTypes>) => {
    dispatch(fetchOrganizationEventsForBookingRequest());
    try {
      const response =
        await organizationEventsForBookingService.getEventForBookingsByOrganization(
          organizationId
        );
      dispatch(fetchOrganizationEventsForBookingSuccess(response));
    } catch (error) {
      const errorMessage = getDynamicTranslation(
        "backendResponses.error.loadOrgaEventsError",
        "snackbars"
      );
      dispatch(fetchOrganizationEventsForBookingFailure(errorMessage));
      enqueueSnackbar(errorMessage, { variant: "error" });
    }
  };
};
